// Trade Safety Page
// Comprehensive guide for safe international trade

import Layout from '@/components/Layout';
import TradeSafetyGuide from '@/components/TradeSafetyGuide';
import SEO from '@/components/SEO';

export default function TradeSafety() {
  return (
    <Layout>
      <SEO 
        title="Trade Safety Guide | GlobalVyapar"
        description="Best practices for secure international trade - payment terms, inspections, documentation"
      />
      <div className="max-w-4xl mx-auto px-4 py-8">
        <TradeSafetyGuide />
      </div>
    </Layout>
  );
}
